module.exports = __webpack_public_path__ + "static/media/filter.f645d71e.svg";